Ext.define('SA.model.LocationSeriesString', {
    singleton: true,

    match(value) {
        return (typeof value === 'string')
            && value.trim().length > 0
            && !value.startsWith('locationSeries:')
            && !SA.model.CustomLocationStringId.match(value);
    }
});